import { render } from "./CubesList.vue?vue&type=template&id=e0b4b86e&scoped=true"
import script from "./CubesList.vue?vue&type=script&lang=js"
export * from "./CubesList.vue?vue&type=script&lang=js"

import "./CubesList.vue?vue&type=style&index=0&id=e0b4b86e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b4b86e"]])

export default __exports__